import { PropTypes } from "aem/ComponentWrapper";
import React from "react";

export default {
  title: "AsyncContent",
  type: "rh/components/content/async",
  config: {
    emptyLabel: "Async Content",
    isEmpty: ({ children }: PropTypes) => React.Children.count(children) === 0
  }
};
